<!-- cdkScrollable: registers the container with the CDK's scroll dispatcher, so overlays opened from a
cell follow their trigger and a drag near the edge auto-scrolls this instead of the page. -->
<div class="table-scroll-container" cdkScrollable [style.max-height]="maxHeight">
  <table
    class="my-regular-table mat-elevation-z8"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
    [cdkDropListDisabled]="!dndEnabled"
    [cdkDropListData]="data"
    [style.--lib-dnd-table-min-width]="minTableWidth"
  >
    <thead>
      <tr>
        <ng-container *ngTemplateOutlet="headersTemplate"></ng-container>
      </tr>
    </thead>

    <tbody>
      @for (element of data; track element; let i = $index) {
        <tr
          [class.pointer]="hoverPointer"
          cdkDrag
          [cdkDragData]="element"
          [cdkDragPreviewContainer]="'parent'"
          (cdkDragStarted)="dragStarted()"
          (click)="handleRowClicked(element)"
        >
          <ng-container *ngTemplateOutlet="rowTemplate; context: { element: element, index: i }"></ng-container>
        </tr>
      }
    </tbody>
  </table>
</div>
